<template>
    <transition name="fade-in">
        <div v-if="loaded" class="calendar-event-detail" :class="{'calendar-event-detail--has-button': event.detail_page, 'calendar-event-detail--compact': compact}">
            <div class="calendar-event-detail__header">
                <p class="h1-alike color-red bold huge-title meteor-title" :key="event.title" v-html="event.title"></p>
                <p class="calendar-event-detail__location" v-html="event.location"></p>
            </div>
            <div class="calendar-date" :class="{'calendar-date--has-enddate': event.enddate}">
                <div class="calendar-date__date">
                    <span class="calendar-date__weekday" v-html="$t('weekdays.' + new Date(event.startdate).getDay())"></span>
                    <span class="calendar-date__day" v-html="new Date(event.startdate).getDate()"></span>
                    <span class="calendar-date__month" v-html="$t('months.' + new Date(event.startdate).getMonth())"></span>
                </div>
                <template v-if="event.enddate">
                    <div class="calendar-date__until" v-html="$t('till')"></div>
                    <div class="calendar-date__date">
                        <span class="calendar-date__weekday" v-html="$t('weekdays.' + new Date(event.enddate).getDay())"></span>
                        <span class="calendar-date__day" v-html="new Date(event.enddate).getDate()"></span>
                        <span class="calendar-date__month" v-html="$t('months.' + new Date(event.enddate).getMonth())"></span>
                    </div>
                </template>
            </div>
            <div class="facts-list">
                <div class="facts-list__header">
                    <span class="facts-list__header-title" v-html="$t('facts')"></span>
                </div>
                <div class="facts-list__item-wrapper">
                    <div class="facts-list__item-inner">
                        <template v-for="fact in event.facts">
                            <template v-if="fact.appearance && fact.appearance === 'double'">
                                <div class="facts-list__item is-double">
                                    <div class="facts-list__item-padder">
                                        <span class="facts-list__title" v-html="$t(fact.long_label_i18n)"></span>
                                        <span class="facts-list__value" v-html="fact.long_value"></span>
                                        <span v-if="fact.long_unit_i18n" class="facts-list__unit" v-html="$t(fact.long_unit_i18n)"></span>
                                    </div>
                                </div>
                                <div class="facts-list__item is-small">
                                    <div class="facts-list__item-padder">
                                        <span class="facts-list__title" v-html="$t(fact.short_label_i18n)"></span>
                                        <span class="facts-list__value" v-html="fact.short_value"></span>
                                        <span v-if="fact.short_unit_i18n" class="facts-list__unit" v-html="$t(fact.short_unit_i18n)"></span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="facts-list__item">
                                    <div class="facts-list__item-padder">
                                        <span class="facts-list__title" v-html="$t(fact.label_i18n)"></span>
                                        <span class="facts-list__value" v-html="fact.value"></span>
                                        <span v-if="fact.unit_i18n" class="facts-list__unit" v-html="$t(fact.unit_i18n)"></span>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
            <template v-if="!compact">
                <div class="main-cta-list">
                    <div class="main-cta-list__inner">
                        <a v-if="event.main_cta_list.registration" class="main-cta-list__item" :href="event.main_cta_list.registration.link" :target="checkAction(event.main_cta_list.registration.action)">
                            <div class="main-cta-list__item-icon">
                                <i class="icon icon-flag">
                                    <svg width="100%" height="100%">
                                        <use xlink:href="../../../assets/svg/sprite.symbol.svg#flag"></use>
                                    </svg>
                                </i>
                            </div>
                            <span class="main-cta-list__text" v-html="$t(event.main_cta_list.registration.label_i18n)"></span>
                        </a>
                        <a v-if="event.main_cta_list.ds_life" class="main-cta-list__item" :href="event.main_cta_list.ds_life.link" :target="checkAction(event.main_cta_list.ds_life.action)">
                            <div class="main-cta-list__item-icon">
                                <i class="icon icon-lightning">
                                    <svg width="100%" height="100%">
                                        <use xlink:href="../../../assets/svg/sprite.symbol.svg#lightning"></use>
                                    </svg>
                                </i>
                            </div>
                            <span class="main-cta-list__text" v-html="$t(event.main_cta_list.ds_life.label_i18n)"></span>
                        </a>
                        <a v-if="event.main_cta_list.start_list" class="main-cta-list__item" :href="event.main_cta_list.start_list.link" :target="checkAction(event.main_cta_list.start_list.action)">
                            <div class="main-cta-list__item-icon">
                                <i class="icon icon-startlist">
                                    <svg width="100%" height="100%">
                                        <use xlink:href="../../../assets/svg/sprite.symbol.svg#startlist"></use>
                                    </svg>
                                </i>
                            </div>
                            <span class="main-cta-list__text" v-html="$t(event.main_cta_list.start_list.label_i18n)"></span>
                        </a>
                        <a v-if="event.main_cta_list.ranking_list" class="main-cta-list__item" :href="event.main_cta_list.ranking_list.link" :target="checkAction(event.main_cta_list.ranking_list.action)">
                            <div class="main-cta-list__item-icon">
                                <i class="icon icon-startlist">
                                    <svg width="100%" height="100%">
                                        <use xlink:href="../../../assets/svg/sprite.symbol.svg#startlist"></use>
                                    </svg>
                                </i>
                            </div>
                            <span class="main-cta-list__text" v-html="$t(event.main_cta_list.ranking_list.label_i18n)"></span>
                        </a>
                    </div>
                </div>
            </template>
            <div class="further-cta-list" :class="{'further-cta-list--compact': compact}">
                <div class="further-cta-list__inner">
                    <template v-if="compact">
                        <div v-if="event.main_cta_list.registration" class="further-cta-list__item-wrapper">
                            <div class="further-cta-list__item-padder">
                                <a class="further-cta-list__item" :href="event.main_cta_list.registration.link" :target="checkAction(event.main_cta_list.registration.action)">
                                    <div class="further-cta-list__icon">
                                        <i class="icon icon-flag">
                                            <svg width="100%" height="100%">
                                                <use xlink:href="../../../assets/svg/sprite.symbol.svg#flag"></use>
                                            </svg>
                                        </i>
                                    </div>
                                    <span class="further-cta-list__text" v-html="$t(event.main_cta_list.registration.label_i18n)"></span>
                                </a>
                            </div>
                        </div>
                        <div v-if="event.main_cta_list.ds_life" class="further-cta-list__item-wrapper">
                            <div class="further-cta-list__item-padder">
                                <a class="further-cta-list__item" :href="event.main_cta_list.ds_life.link" :target="checkAction(event.main_cta_list.ds_life.action)">
                                    <div class="further-cta-list__icon">
                                        <i class="icon icon-lightning">
                                            <svg width="100%" height="100%">
                                                <use xlink:href="../../../assets/svg/sprite.symbol.svg#lightning"></use>
                                            </svg>
                                        </i>
                                    </div>
                                    <span class="further-cta-list__text" v-html="$t(event.main_cta_list.ds_life.label_i18n)"></span>
                                </a>
                            </div>
                        </div>
                        <div v-if="event.main_cta_list.start_list" class="further-cta-list__item-wrapper">
                            <div class="further-cta-list__item-padder">
                                <a class="further-cta-list__item" :href="event.main_cta_list.start_list.link" :target="checkAction(event.main_cta_list.start_list.action)">
                                    <div class="further-cta-list__icon">
                                        <i class="icon icon-startlist">
                                            <svg width="100%" height="100%">
                                                <use xlink:href="../../../assets/svg/sprite.symbol.svg#startlist"></use>
                                            </svg>
                                        </i>
                                    </div>
                                    <span class="further-cta-list__text" v-html="$t(event.main_cta_list.start_list.label_i18n)"></span>
                                </a>
                            </div>
                        </div>
                        <div v-if="event.main_cta_list.ranking_list" class="further-cta-list__item-wrapper">
                            <div class="further-cta-list__item-padder">
                                <a class="further-cta-list__item" :href="event.main_cta_list.ranking_list.link" :target="checkAction(event.main_cta_list.ranking_list.action)">
                                    <div class="further-cta-list__icon">
                                        <i class="icon icon-startlist">
                                            <svg width="100%" height="100%">
                                                <use xlink:href="../../../assets/svg/sprite.symbol.svg#startlist"></use>
                                            </svg>
                                        </i>
                                    </div>
                                    <span class="further-cta-list__text" v-html="$t(event.main_cta_list.ranking_list.label_i18n)"></span>
                                </a>
                            </div>
                        </div>
                    </template>
                    <div v-for="further_cta in event.further_cta_list" class="further-cta-list__item-wrapper">
                        <div class="further-cta-list__item-padder">
                            <a class="further-cta-list__item" :href="further_cta.link" :target="checkAction(further_cta.action)">
                                <div v-if="!further_cta.icon" class="further-cta-list__icon"></div>
                                <div v-if="further_cta.icon === 'house'" class="further-cta-list__icon">
                                    <i class="icon icon-house">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#house"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'train'" class="further-cta-list__icon">
                                    <i class="icon icon-train">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#train"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'iphone'" class="further-cta-list__icon">
                                    <i class="icon icon-iphone">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#iphone"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'weather'" class="further-cta-list__icon">
                                    <i class="icon icon-weather">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#weather"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'diploma'" class="further-cta-list__icon">
                                    <i class="icon icon-diploma">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#diploma"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'pin'" class="further-cta-list__icon">
                                    <i class="icon icon-pin">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#pin"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'camera'" class="further-cta-list__icon">
                                    <i class="icon icon-camera">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#camera"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'hotel'" class="further-cta-list__icon">
                                    <i class="icon icon-hotel">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#hotel"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'video'" class="further-cta-list__icon">
                                    <i class="icon icon-video">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#video"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'info'" class="further-cta-list__icon">
                                    <i class="icon icon-info">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#info"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'calendar'" class="further-cta-list__icon">
                                    <i class="icon icon-calendar">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#calendar"></use>
                                        </svg>
                                    </i>
                                </div>
                                <div v-if="further_cta.icon === 'bulb'" class="further-cta-list__icon">
                                    <i class="icon icon-bulb">
                                        <svg width="100%" height="100%">
                                            <use xlink:href="../../../assets/svg/sprite.symbol.svg#bulb"></use>
                                        </svg>
                                    </i>
                                </div>
                                <span class="further-cta-list__text" v-html="$t(further_cta.label_i18n)"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="event.detail_page">
                <!-- C02 Button -->
                <a href="" class="button button--color-red " v-bind:href="event.detail_page">mehr infos</a>
                <!-- END - C02 Button -->
            </template>
        </div>
    </transition>
</template>
<script>
    const loaded = {};
    export default
    {
        props: ['eventid', 'userid', 'compact'],
        data()
        {
            return {
                "loaded": false
            };
        },
        watch:
        {
            loaded()
            {
                this.$emit('loaded', this.event);
            }
        },
        methods:
        {
            /**
             * Checks if an link should be opened in a new window, depending on the action
             *
             * @param {string} action to be checked
             * @return {string|boolean} depending on action
             */
            checkAction(action)
            {
                if (['extern', 'download'].indexOf(action) > -1)
                {
                    // Sets attribute target to _blank
                    return '_blank';
                }
                else
                {
                    // Removes whole attribute
                    return false;
                }
            },
        },
        /**
         * The created lifecycle hook
         *
         * Loads the event details when not already fetched
         */
        created()
        {
            let self = this;
            // Check if already loaded
            if (!loaded.hasOwnProperty(this.eventid))
            {
                let userid = this.userid ? '&userid=' + this.userid : '';
                fetch(window.DS.apis.eventDetail + '?lang=' + window.DS.lang + '&eventid=' + this.eventid + userid,
                {
                    credentials: 'same-origin'
                }).then(res => res.json()).then(json =>
                {
                    self.loaded = true;
                    self.event = json;
                    loaded[this.eventid] = json;
                }).catch((error) =>
                {
                    throw new Error(error);
                });
            }
            else
            {
                self.loaded = true;
                self.event = loaded[this.eventid];
            }
        }
    };
</script>
<style>
    /* TODO: remove this from this file and insert final transitions in scss file from mish */
    
    .fade-in-enter-active,
    .fade-in-leave-active {
        transition: opacity .5s ease-in-out;
    }
    /*.h1-alike {
        transition: transform .5s ease-in-out;
        transform: translateY(0);
    }*/
    
    .fade-in-enter,
    .fade-in-leave-to {
        opacity: 0;
    }
    
    .fade-in-enter .h1-alike,
    .fade-in-leave-to .h1-alike {
        /*transform: translateY(20px);*/
    }
</style>